import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RemotePowerService } from './_services/remote-power.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'app works!';

  constructor() { }

  ngOnInit(): void {
  }
  
}
